<template>
  <v-dialog v-model="dialog" persistent max-width="720px">
    <v-card>
      <v-toolbar dark color="info">
        <v-toolbar-title>Manuel Dünya Kuru Girişi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="iptal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-alert v-if="bilgiGoster" :value="true" color="warning" icon="warning" outline>
          Bu tarihten önceki dünya kur bilgisi sistemde bulunmamaktadır. Lütfen aktarımın devam edebilmesi için ilgili tarihli kuru manuel giriniz. Bu bilgilendirme bu tarayıcıda yalnızca bir kez gösterilir.
        </v-alert>

        <div class="mb-3">
          Girilen değer doğrudan dönüşüm kurudur. Örnek: <b>1 EUR = 55.97 TRY</b> ise alana <b>55.97</b> yazınız.
        </div>

        <v-card
          v-for="item in kayitlar"
          :key="item.Anahtar"
          class="mb-3 pa-3"
          flat
          color="grey lighten-4"
        >
          <v-layout row wrap align-center>
            <v-flex xs12 sm4>
              <b>{{ tarihGoster(item.Tarih) }}</b>
            </v-flex>

            <v-flex xs12 sm4>
              1 {{ item.KaynakParaBirimi }} = ? {{ item.HedefParaBirimi }}
            </v-flex>

            <v-flex xs12 sm4>
              <v-text-field
                v-model="item.Kur"
                type="number"
                step="0.000001"
                min="0"
                :label="'1 ' + item.KaynakParaBirimi + ' kaç ' + item.HedefParaBirimi + '?'"
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>

        <v-alert v-if="hata" :value="true" color="error" icon="warning" outline>
          {{ hata }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="iptal">Vazgeç</v-btn>
        <v-btn color="info" dark @click="kaydet">Kaydet ve Aktarımı Tekrar Dene</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      kayitlar: [],
      hata: "",
      bilgiGoster: false,
      resolve: null,
      kurAnahtar: "arkman_aktarim_earth_kurlari_v1",
      uyariAnahtar: "arkman_aktarim_earth_uyari_v1",
    };
  },

  methods: {
    open(kayitlar) {
      this.hata = "";
      this.bilgiGoster = window.localStorage.getItem(this.uyariAnahtar) !== "1";

      var mevcut = this.kurlariOku();
      var benzersiz = {};
      var sonuc = [];

      (kayitlar || []).forEach((item) => {
        var tarih = String(item.Tarih || "").slice(0, 10);
        var kaynak = String(item.KaynakParaBirimi || "").trim().toUpperCase();
        var hedef = String(item.HedefParaBirimi || "").trim().toUpperCase();

        if (!tarih || !kaynak || !hedef) {
          return;
        }

        var anahtar = tarih + "|" + kaynak + "|" + hedef;

        if (benzersiz[anahtar]) {
          return;
        }

        benzersiz[anahtar] = true;

        sonuc.push({
          Anahtar: anahtar,
          Tarih: tarih,
          KaynakParaBirimi: kaynak,
          HedefParaBirimi: hedef,
          Kur: mevcut[anahtar] || null,
        });
      });

      this.kayitlar = sonuc;
      this.dialog = true;

      if (this.bilgiGoster) {
        window.localStorage.setItem(this.uyariAnahtar, "1");
      }

      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },

    kurlariOku() {
      var ham = window.localStorage.getItem(this.kurAnahtar);

      if (!ham) {
        return {};
      }

      try {
        var veri = JSON.parse(ham);
        return veri && typeof veri === "object" ? veri : {};
      } catch (e) {
        return {};
      }
    },

    kaydet() {
      var mevcut = this.kurlariOku();

      for (var i = 0; i < this.kayitlar.length; i++) {
        var item = this.kayitlar[i];
        var kur = Number(String(item.Kur || "").replace(",", "."));

        if (!isFinite(kur) || kur <= 0) {
          this.hata =
            this.tarihGoster(item.Tarih) +
            " - " +
            item.KaynakParaBirimi +
            " / " +
            item.HedefParaBirimi +
            " için geçerli bir kur giriniz.";
          return;
        }

        mevcut[item.Anahtar] = kur;
      }

      try {
        window.localStorage.setItem(this.kurAnahtar, JSON.stringify(mevcut));
      } catch (e) {
        this.hata = "Manuel kur bilgileri tarayıcıya kaydedilemedi.";
        return;
      }

      this.dialog = false;

      if (this.resolve) {
        this.resolve(true);
        this.resolve = null;
      }
    },

    iptal() {
      this.dialog = false;

      if (this.resolve) {
        this.resolve(false);
        this.resolve = null;
      }
    },

    tarihGoster(tarih) {
      var p = String(tarih || "").slice(0, 10).split("-");

      if (p.length !== 3) {
        return tarih;
      }

      return p[2] + "." + p[1] + "." + p[0];
    },
  },
};
</script>
